export default "__VITE_ASSET__CXBKedCG__"